(function () {
  'use strict';

  /* --------------------------------------------------------------------
   * PK REVIEW COUNT - 2026-08-10, corrected 2026-09-03
   *
   * Judge.me is the source of truth for both the count and the average.
   * Nothing on the site should hardcode either one.
   *
   * This script reads them off the Judge.me preview badge and writes them into:
   *   1. the badge label itself
   *   2. any [data-pk-review-count] element  (e.g. header bar, CRO band)
   *   3. any [data-pk-review-rating] element (e.g. CRO band stars)
   *   4. any {{review_count}} / {{review_rating}} token in page text
   *
   * 2026-09-03 FIX. This file used to carry its own hardcoded fallback of '566'
   * - a second invented number, which is the exact bug the file was written to
   * remove. On pages with no Judge.me product badge (the homepage, for one)
   * there is never a live count, so that 566 was written straight over the
   * correct value the server had already rendered from the theme setting. The
   * announcement bar therefore claimed 566 reviews while the hero and the
   * product page both said 599.
   *
   * The fallback is now whatever the server rendered into
   * [data-pk-review-count]. If there is no live count AND no server value, the
   * script writes nothing rather than inventing a number.
   * -------------------------------------------------------------------- */

  var COUNT_TOKEN = /\{\{\s*review_count\s*\}\}/g;
  var RATING_TOKEN = /\{\{\s*review_rating\s*\}\}/g;

  var state = { count: '', rating: '' };
  var serverCount = null;

  /* Read once, lazily: the value Liquid rendered before any JS ran. */
  function serverRenderedCount() {
    if (serverCount !== null) return serverCount;
    var el = document.querySelector('[data-pk-review-count]');
    var raw = el && el.textContent ? el.textContent.replace(/[^0-9]/g, '') : '';
    serverCount = raw && Number(raw) > 0 ? raw : '';
    return serverCount;
  }

  function fallbackCount() {
    var override = window.PeekoraReviewCountFallback;
    if (override && Number(override) > 0) return String(Number(override));
    return serverRenderedCount();
  }

  function resolvedCount() {
    return state.count || fallbackCount();
  }

  function readBadge(wrapper) {
    if (!wrapper) return;

    var count = wrapper.getAttribute('data-number-of-reviews') || '';
    if (!count) {
      var countEl = wrapper.querySelector('.jdgm-prev-badge__text');
      var m = countEl && countEl.textContent.match(/([\d,]+)\s*review/i);
      if (m) count = m[1].replace(/,/g, '');
    }

    var rating = wrapper.getAttribute('data-average-rating') || '';
    if (!rating) {
      var textEl = wrapper.querySelector('.jdgm-prev-badge__text');
      var rm = textEl && textEl.textContent.match(/\d+(?:\.\d+)?/);
      if (rm) rating = rm[0];
    }

    if (count && Number(count) > 0) state.count = String(Number(count));
    if (rating && !isNaN(Number(rating)) && Number(rating) > 0) state.rating = Number(rating).toFixed(2);
  }

  function labelFor() {
    var n = resolvedCount();
    if (!n) return 'Happy Parents';
    return n + ' Happy Parent' + (Number(n) === 1 ? '' : 's');
  }

  function parentLabelFor(count) {
    return Number(count) === 1 ? 'Happy Parent' : 'Happy Parents';
  }

  function updateBadge(wrapper) {
    if (!wrapper) return false;
    var textEl = wrapper.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return false;

    readBadge(wrapper);

    var ratingLabel = state.rating ? state.rating + '/5' : 'Top Rated';
    var label = labelFor();
    var signature = ratingLabel + '|' + label;

    if (wrapper.dataset.pkReviewSignature === signature) return true;
    wrapper.dataset.pkReviewSignature = signature;

    textEl.replaceChildren();

    var ratingSpan = document.createElement('span');
    ratingSpan.className = 'pk-review-rating';
    ratingSpan.textContent = ratingLabel;

    var divider = document.createElement('span');
    divider.className = 'pk-review-divider';
    divider.setAttribute('aria-hidden', 'true');
    divider.textContent = ' • ';

    var trustSpan = document.createElement('span');
    trustSpan.className = 'pk-review-trust';
    trustSpan.textContent = label;

    textEl.append(ratingSpan, divider, trustSpan);
    wrapper.classList.add('pk-review-badge-ready');
    wrapper.setAttribute('aria-label', ratingLabel + ', ' + label);
    return true;
  }

  function fillSlots() {
    var count = resolvedCount();

    /* No live count and no server value: leave the DOM alone rather than
       writing a blank or an invented number into a public trust claim. */
    if (count) {
      document.querySelectorAll('[data-pk-review-count]').forEach(function (el) {
        if (el.textContent !== count) el.textContent = count;
      });

      var parentLabel = parentLabelFor(count);
      document.querySelectorAll('[data-pk-review-label]').forEach(function (el) {
        if (el.textContent !== parentLabel) el.textContent = parentLabel;
      });
    }

    if (state.rating) {
      var ratingText = state.rating + '/5';
      document.querySelectorAll('[data-pk-review-rating]').forEach(function (el) {
        if (el.textContent !== ratingText) el.textContent = ratingText;
      });
    }
  }

  /* Replace {{review_count}} / {{review_rating}} in any text node.
     Text nodes only - never touches markup, scripts or styles. */
  function fillTokens() {
    var count = resolvedCount();
    var rating = state.rating;

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentNode;
        if (!p) return NodeFilter.FILTER_REJECT;
        var tag = p.nodeName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') return NodeFilter.FILTER_REJECT;
        if (node.nodeValue.indexOf('{{') === -1) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);

    nodes.forEach(function (node) {
      var next = node.nodeValue;
      if (count) next = next.replace(COUNT_TOKEN, count);
      if (rating) next = next.replace(RATING_TOKEN, rating + '/5');
      else next = next.replace(RATING_TOKEN, '').replace(/\s{2,}/g, ' ');
      if (next !== node.nodeValue) node.nodeValue = next;
    });
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var badges = scope.querySelectorAll('.peekora-product__reviews .jdgm-prev-badge, .pkcv__reviews .jdgm-prev-badge, body.template-product .jdgm-prev-badge');
    badges.forEach(updateBadge);
    fillSlots();
    fillTokens();
    return badges.length > 0;
  }

  function init() {
    serverRenderedCount();
    fillTokens();
    scan(document);

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (scan(document) || attempts >= 20) window.clearInterval(timer);
    }, 300);

    var target =
      document.querySelector('.peekora-product__reviews') ||
      document.querySelector('.pkcv__info') ||
      document.querySelector('.peekora-product') ||
      document.body;
    if (!target || !window.MutationObserver) return;

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        scan(target);
      });
    });

    observer.observe(target, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
}());
